import React, { useContext, useEffect, useState } from 'react'
import { GlobalState } from '../../../../../globalState';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import DashFooter from '../../footer/DashFooter';
import DashMenu from '../../menu/DashMenu';
import DashNavbar from '../../navbar/Navbar';
import { appAddress } from '../../../../../App';

export default function AboutDash() {
    const state = useContext(GlobalState);
    const [abouts, setAbouts] = useState([]);
    // const [pAbouts, pSetAbouts] = useState([]);
    // const [aAbouts, aSetAbouts] = useState([]);
    const [selectedAbout, setSelectedAbout] = useState(null);
    // const [token] = useSelector(state => state.token);
    const [callback, setCallback] = state.aboutUsAPI.callback;
    const [editAbout, setEditAbout] = useState({ desc: '', pDesc: '', aDesc: '' });

    // console.log('about: ', editAbout.desc)

    // Fetch about data on mount and update
    useEffect(() => {
        const fetchAbouts = async () => {
            try {
                const res = await axios.get(`${appAddress}/api/about`);
                // const res = await axios.get(`/api/about`);
                setAbouts(res.data);
                // pSetAbouts(res.data);
                // aSetAbouts(res.data);

                if (res.data.length > 0) {
                    setSelectedAbout(res.data[0]); 
                } else {
                    setSelectedAbout(null);
                    setEditAbout({ desc: '', pDesc: '', aDesc: '' }); 
                }
            } catch (err) {
                console.error('Error fetching about section:', err);
            }
        };

        fetchAbouts();
    }, [callback]);

    // Update editAbout whenever selectedAbout changes
    useEffect(() => {
        if (selectedAbout) {
            setEditAbout({
                desc: selectedAbout.desc || '',
            pDesc: selectedAbout.pDesc || '',
            aDesc: selectedAbout.aDesc || '',
            });
        }
    }, [selectedAbout]);
    

    const handleChangeInput = (e) => {
        setEditAbout({ ...editAbout, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('desc', editAbout.desc);
            formData.append('pDesc', editAbout.pDesc);
            formData.append('aDesc', editAbout.aDesc);

            if (selectedAbout) {
                // Update existing about section
                await axios.put(`${appAddress}/api/about/${selectedAbout._id}`, { desc: editAbout.desc, pDesc: editAbout.pDesc, aDesc: editAbout.aDesc},{
                // await axios.put(`/api/about/${selectedAbout._id}`, { 
                    desc: editAbout.desc, 
                    pDesc: editAbout.pDesc, 
                    aDesc: editAbout.aDesc, 
                });
                toast.success('آپدیت انجام شد');
            } else {
                // Create new about section
                await axios.post(`${appAddress}/api/about`, { desc: editAbout.desc, pDesc: editAbout.pDesc, aDesc: editAbout.aDesc },{
                // await axios.post(`/api/about`, { 
                    desc: editAbout.desc, 
                    pDesc: editAbout.pDesc, 
                    aDesc: editAbout.aDesc,  
                });
                toast.success('آپدیت انجام شد');
            }

            setCallback(!callback);
        } catch (err) {
            console.error('Error saving about section:', err);
            toast.error(err.response?.data?.msg || 'An error occurred');
        }
    };


    return (
        <div className='bg-[#0c1a33] text-teal-50 ltr'>
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl pauseOnFocusLoss draggable pauseOnHover />
            <DashNavbar />
            <div className='flex'>
                <div className='w-[250px] p-5 border-r-4 ltr mt-11'>
                    <DashMenu />
                </div>
                <div className='p-4 w-[100%] flex flex-col items-center font-englishTitle'>
                    <h2 className="mb-4 text-2xl  semibold ">About US</h2>
                    <hr className="text-slate-300 p-1 w-[25%] mt-4 mb-6" />
                    <form onSubmit={handleSubmit} className="w-full max-w-lg font-english">
                        <textarea
                            name='desc'
                            value={editAbout.desc}
                            onChange={handleChangeInput}
                            className="w-full p-2 text-center text-black border rounded-md mb-4"
                            placeholder="english"
                            rows="5"
                        />
                        <textarea
                            name='pDesc'
                            value={editAbout.pDesc}
                            onChange={handleChangeInput}
                            className="w-full p-2 text-center text-black border rounded-md mb-4 font-persian"
                            placeholder="persian"
                            rows="5"
                        />
                        <textarea
                            name='aDesc'
                            value={editAbout.aDesc}
                            onChange={handleChangeInput}
                            className="w-full p-2 text-center text-black border rounded-md mb-4 font-persian"
                            placeholder="arabic"
                            rows="5"
                        />
                        <button type="submit" className="p-2 font-englishTitle w-[20%] px-4 mt-4 font-bold text-white bg-orange-600 rounded hover:bg-orange-700">
                            {selectedAbout ? 'اپدیت' : 'جدید'}
                        </button>
                    </form>
                </div>
            </div>
            <div className='mt-11'>
                <DashFooter />
            </div>
        </div>
    );
}
